// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  msgId: __t.u64().primaryKey().name("msg_id"),
  worldId: __t.u64().name("world_id"),
  sender: __t.identity(),
  senderName: __t.string().name("sender_name"),
  kind: __t.string(),
  target: __t.identity(),
  posX: __t.f32().name("pos_x"),
  posZ: __t.f32().name("pos_z"),
  text: __t.string(),
  at: __t.timestamp(),
});
